import axios from "axios";

export const enviarNotificacionPrueba = async (entidad) => {

    let data = JSON.stringify(entidad);

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
      //  url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/7c0a9dd9-4f25-42da-ad88-61dafbc6f3fa', //test
       url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/7c0a9dd9-4f25-42da-ad88-61dafbc6f3fa',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
            return true
        })
        .catch((error) => {
            console.log(error);
            return false
        });

}